import { useEffect } from 'react';
import { Language } from '../../types/i18n';
import './styles.css';

interface LanguageDialogProps {
  isOpen: boolean;
  onSelect: (language: Language) => void;
}

export function LanguageDialog({ isOpen, onSelect }: LanguageDialogProps) {
  // Prevent scrolling when dialog is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="language-dialog-overlay">
      <div className="language-dialog">
        <div className="language-dialog-content">
          <h2 className="language-dialog-title">🌐 Language / 언어</h2>
          <p className="language-dialog-subtitle">
            Please select your language<br />
            사용할 언어를 선택해주세요
          </p>

          <div className="language-dialog-buttons">
            <button
              className="language-dialog-button"
              onClick={() => onSelect('ko')}
            >
              <span className="language-flag">🇰🇷</span>
              <span className="language-name">한국어</span>
            </button>
            <button
              className="language-dialog-button"
              onClick={() => onSelect('en')}
            >
              <span className="language-flag">🇺🇸</span>
              <span className="language-name">English</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
